$(function () {
  var fotoramaContainer = $('.fotorama');
  var fotorama;
  var showArrows;

  function showFullScreenOnClick() {
    $(document).on('click', '.fotorama', function (e) {
      // check that we clicked on an image rather
      // than a navigation arrow
      var clickedElement = $(e.target);

      // Get parent fotorama gallery data
      var parentFotoramaContainer = clickedElement.parents('.fotorama');
      fotorama = parentFotoramaContainer.data('fotorama');

      // Make sure we're not clicking a thumbnail
      var clickedFullImage = clickedElement.parent('.fotorama__stage__frame').length > 0;


      if (clickedElement.is('img') && clickedFullImage) {
        fotorama.requestFullScreen();
      }
    });
  }

  function cancelFullScreenOnClickOutsideImage() {
    $(document).on('click', '.fotorama__stage__frame.fotorama__loaded--full.fotorama__active', function (e) {
      var clickedElement = $(e.target);
      if (!clickedElement.is('img')) {
        fotorama.cancelFullScreen();
      }
    });
  }

  if (!Reverb.MobileDetection.isMobileBrowser()) {
    showFullScreenOnClick();
    cancelFullScreenOnClickOutsideImage();
    showArrows = 'true';
  } else {
    showArrows = 'always';
  }

  // Disable swipe on desktop devices, mobile only
  fotoramaContainer.fotorama({
    swipe: Reverb.MobileDetection.isMobileBrowser(),
    arrows: showArrows,
    loop: true
  });
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/image-gallery.js